import { Component, OnDestroy, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { LocalCacheService } from '../../local-cache/local-cache.service';
import { UserService } from '../../user/user.service';
import { MsalV3Service } from '../../services/msal-V3.service';
import { IdleSessionService } from '../../idle/idle-session.service';

@Component({
    selector: 'nalco-logout',
    templateUrl: './logout.component.html',
    standalone: false
})
export class LogoutComponent implements OnInit, OnDestroy {
  showLoader = true;

  constructor(
    private authService: MsalService,
    private cacheService: LocalCacheService,
    private userService: UserService,
    private msalV3Service:MsalV3Service,
    private idleSessionService: IdleSessionService,
  ) {
    this.msalV3Service.completeClientLogout();
  }

  ngOnInit(): void {
    this.userService.setUserInfo(null);
    //fix user logout and re-login page always loading bug.
    this.userService.clear();

    const isCoordinatedLogout = this.idleSessionService.isLogoutInProgressValue();
    const shouldExecuteRedirect =
      !isCoordinatedLogout || this.idleSessionService.shouldExecuteLogout();

    if (shouldExecuteRedirect) {
      this.idleSessionService.markLogoutExecuted();
      this.authService.logout();
      return;
    }

    this.showLoader = false;
  }

  signInAgain(): void {
    this.idleSessionService.stopSession();
    this.msalV3Service.login();
  }

  ngOnDestroy(): void {
    this.cacheService.storeData('returnUrl','/');
  }

}
